/**
 * @deprecated This file is deprecated and should no longer be used or modified.
 * Please use shared UI adapters instead.
 */
const appendQueryParam = (url, key, value) => {
  if (value === '' || value === null) {
    return url;
  }
  const punctuation = /\?/.test(url) ? '&' : '?';
  let query = encodeURIComponent(key);
  if (value !== undefined && value !== '') {
    query = query.concat('=', encodeURIComponent(value));
  }
  return url + punctuation + query;
};
/**
 * @deprecated
 */
const appendQueryObject = (url, queryObject) => {
  if (queryObject === null || queryObject === undefined) {
    return url;
  }
  let result = url;
  Object.keys(queryObject).forEach(key => {
    const value = queryObject[key];
    if (value === undefined) {
      return;
    }
    result = appendQueryParam(result, key, value);
  });
  return result;
};
export { appendQueryObject, appendQueryParam };